export default "__VITE_ASSET__CPBmcN9Y__"